import { Container, makeStyles } from '@material-ui/core';
import React from 'react';
import { HashRouter, Redirect, Route, Switch } from 'react-router-dom';
import CubeList from './Cubes/CubeList';
import TrafficShapingContent from "./TrafficShaping/TrafficShapingContent";
import GroupList from "./Groups/GroupList";
import GroupContent from "./Groups/GroupContent";
import ScoreCardContent from "./ScoreCards/ScoreCardContent";
import LiveViewContent from "./LiveView/LiveViewContent";
import GamePointsContent from "./GamePoints/GamePointsContent";
import CubeContent from "./Cubes/CubeContent";
import OperatorList from "./Operators/OperatorList";
import LeaderboardContent from "./Leaderboard/LeaderboardContent";

const useStyles = makeStyles((theme) => ({
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
    backgroundColor: '#F0F0F0'
  },
  container: {
    padding: theme.spacing(2),
  },
}));

export default function MainContent()
{
  const classes = useStyles();
  
  return (
    <main className={classes.content}>
      <div className={classes.appBarSpacer} />
      <div className={classes.container}>

        <Switch>
          <Route path="/cube/:cubeId" component={CubeContent} />
          <Route path="/cube" component={CubeList} />

          <Route path="/group/:groupId" component={GroupContent} />
          <Route path="/group" component={GroupList} />

          <Route path="/scoreCards/:playerPairId" component={ScoreCardContent} />

          <Route path="/GamePoints" component={GamePointsContent} />

          <Route path="/Operators" component={OperatorList} />

          <Route path="/Leaderboard" component={LeaderboardContent} />

          <Route path="/TrafficShaping" component={TrafficShapingContent} />

          <Route path="/LiveView" component={LiveViewContent} />

          <Route render={() => (<Redirect to="/cube" />)} />
        </Switch>
        
      </div>
    </main>
  );
}